/**
 * Middleware de erro da aplicação
 * Responsabilidade única: exibir mensagens de erro ao usuário via toast
 * Desacoplado de qualquer lógica HTTP específica
 */
import { toastWarning } from '@/lib/toast';

interface AppErrorEvent extends CustomEvent {
  detail: {
    status: number;
    message: string;
  };
}

/**
 * Inicializa o listener para eventos de erro da aplicação
 * Converte eventos em mensagens visuais (toasts)
 */
export function setupAppErrorMiddleware(): void {
  window.addEventListener(
    'http-error',
    (event) => {
      const appError = event as AppErrorEvent;
      const { status, message } = appError.detail;

      // Map de mensagens por status
      const statusMessages: Record<number, string> = {
        403: 'Acesso negado',
        401: 'Sessão expirada',
      };

      const title = statusMessages[status] || 'Erro';

      toastWarning(`${title}: ${message}`);
    }
  );
}
